import React from "react";
import { Grid, Box, Typography, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import ProductCard from "./ProductCard";

/**
 * Product Grid component
 * Displays products in a responsive grid layout
 *
 * @param {Object} props - Component props
 * @param {Array} props.products - List of products to display
 * @param {boolean} props.loading - Whether products are loading
 * @returns {JSX.Element} The ProductGrid component
 */
const ProductGrid = ({ products, loading }) => {
  const { t } = useTranslation("common");
  const { t: tProducts } = useTranslation("products");

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!products || products.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="h6" color="text.secondary">
          {tProducts("catalog.search.noResults")}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {tProducts("catalog.filters.clear")}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {products.map((product) => (
        <Grid 
          item 
          xs={12} 
          key={product.id}
          sx={{
            '@media (min-width: 750px)': {
              maxWidth: '50%',
              flexBasis: '50%',
            },
            '@media (min-width: 1500px)': {
              maxWidth: '33.333333%',
              flexBasis: '33.333333%',
            }
          }}
        >
          <ProductCard product={product} />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductGrid;
